export enum WeekDayEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const getWeekDayEnumByIndex = (index: number) => {
  const weekdayMapping = [
    WeekDayEnum.SUNDAY, // 0
    WeekDayEnum.MONDAY, // 1
    WeekDayEnum.TUESDAY, // 2
    WeekDayEnum.WEDNESDAY, // 3
    WeekDayEnum.THURSDAY, // 4
    WeekDayEnum.FRIDAY, // 5
    WeekDayEnum.SATURDAY, // 6
  ];
  return weekdayMapping[index];
};
